import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login.component';
import { RedirectMfaComponent } from './redirect-mfa/redirect-mfa.component';
import { RedirectMFAGuardService } from './redirect-mfa/services/redirect-mfa-guard.service';


const routes: Routes = [
  {
    path: '',
    component: LoginComponent
  },
  {
    path: 'redirectMFA',
    component: RedirectMfaComponent,
    canActivate: [RedirectMFAGuardService]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LoginRoutingModule { }
